import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Link, Stack} from '@travel-frontend/ui-components';

type Props = {
  textColor: string;
  badgeColor: string;
};

export const Container = styled(Stack)<Props>(
  ({theme, textColor, badgeColor}) => css`
    gap: 2px;
    max-height: 68px;
    text-align: center;
    border-radius: 20px;
    color: ${textColor};
    padding: 8px 16px 8px 16px;
    z-index: 10;
    min-width: 140px;
    background-color: ${badgeColor};

    ${theme.respondTo(
      'lg',
      css`
        max-width: 328px;
      `
    )};

    ${Link} {
      color: ${textColor};
    }

    ${theme.respondUpTo(
      'md',
      css`
        max-height: 76px;
        padding: 8px 2px 8px 12px;
        border-radius: 40px 0 0 40px;
        text-align: start;
        margin-right: -16px;
        margin-left: -24px;
        min-width: 0;
      `
    )}

    a:hover {
      color: inherit;
      text-decoration: none;
    }
  `
);
